import { Box } from "@mui/material"

export default function BtnActionWrapper({
    children
}: BtnActionWrapperProps) {

    return (
        <Box
            position={{ xs: "unset", md: "absolute" }}
            right={0}
            bottom={0}
            width='100%'
            display={'flex'}
            justifyContent='flex-end'
            gap={2}
            mt={2}
            sx={{pointerEvents: 'none'}}
        >{children}</Box>
    )
}

interface BtnActionWrapperProps {
    children: React.ReactNode
}